<template>
  <div class="pk-animation-standalone">
    <animation-view :inputData="animationData">

    </animation-view>
  </div>
</template>

<script>
import Vue from 'vue';
import * as $ from 'jquery';
import AnimationView from '../../components/AnimationView';
import { FudapiService } from '../../utils/fudapi.service';
import Util from '../../utils/util';
import { mapGetters } from 'vuex';
import { Observable, of } from 'rxjs';

export default Vue.extend({
  components: {
    'animation-view': AnimationView
  },

  data() {
    return {
      startLoad: {
        deepestReached: false,
        threads: []
      },
      animationData: undefined
    };
  },
  watch: {
    activeSlideset() {
      Util.checkStartLoad({
        loadingCount: 0,
        startLoad: this.startLoad,
        retryCondition: () => { 
          return this.activeSlideset.slides.length <= 0;
        },
        allDoneCallback: () => {
          this.animationData = this.activeSlideset.slides
          .find(sl => sl._id === this.$route.params.sid)
          .getAnimationByOrder(parseInt(this.$route.params.order, 10));
        }
      });
    }
  },
  created() {
    this.$store.dispatch('fetchSelectArchiveEdition', {
      startLoad: this.startLoad,
      id: parseInt(this.$route.params.ssid, 10),
      cb: (res) => {
        if (res && res[0]) {
          this.$store.dispatch('archive/select.slideset', res[0]);
        }
      }
    });
  },

  mounted() {
    $('header.pk-header').hide();
    $('.pk-nav').hide();
    $('.pk-footer').hide();

  },

  destroyed() {
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },

  computed: {
    activeSlideset() {
      return this.$store.getters['archive/activeSlideset'];
    },
    activeSlide() {
      return this.$store.getters['archive/activeSlide'];
    },
  },

  methods: {
  }
});
</script>

<style lang="scss" scoped>
// @import '../../assets/scss/variable.scss';
// @import '../../assets/scss/layout.scss';
// @import '../../assets/scss/color.scss';
// @import '../../assets/scss/size.scss';


</style>